function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.299,
    height: 19.014,
    viewBox: "0 0 11.299 19.014",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8356",
    d: "m349.885 498.358-4.278-4.148-4.209 4.149a.543.543 0 0 1-.9-.486V480.5h10.3v17.372a.554.554 0 0 1-.913.486z",
    transform: "translate(-340 -480)",
    style: {
      fill: "none",
      stroke: "#707070",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.d3167c5966d12500fe08dc46ec108ec9.svg";
export { ForwardRef as ReactComponent };